<template>
    <div class="color-picker-wrapper">  
      <app-color-picker v-model="backgroundColorInteraction"
                        :data-control-name="label"
                        :data-show-checkbox="false"
                        removeCheckboxDiv
                        :isGradient="isGradient"
                        :eyedropper="false"
                        backGroundColorEditor
                        @selectedFalse="emitSelectedFalse"
                        type="BACKGROUND"
                        :data-active="item.estilo && item.estilo.backgroundColor && item.estilo.backgroundColor.active"
                        :interaction="dataInteraction"></app-color-picker>     
    </div>
</template>
  
<script>
    import EventBus from '@packages/event-bus'
    import AppColorPicker from './ColorPicker'
    import _ from 'lodash'

    export default {
    components: {
        AppColorPicker,
    },

    props: {      

        dataShowLabel: {
            type: Boolean,
            required: false,
            default: true,
        },

        dataInteraction: {
            type: Object,
            required: true
        },

        dataMaxLength: {
            type: Number
        },

        label: {
            type: String,
            required: true
        },

        isGradient: {
            type: Boolean,
            default: false            
        }
    },
    data() {
        return {
        }
    },       

    computed: {        
        
        backgroundColorInteraction: {                
            get() {
                return this.get('backgroundColorInteraction')
            },
            set(val) {
                const isNotGradientColor = typeof val === "object"
                
                const payload = {color: val, attr: 'backgroundColorInteraction'}

                const isValid = isNotGradientColor ? this.isValidColorSelection(payload) : true

                if(isValid) {                    

                    this.set(payload)
                }
            }
        },        

        style() {
            const style = {}
            const item = this.dataInteraction

            _.forEach(item.estilo, (val, key) => {
                style[key] = val
            })

            return style
        },

        item() {
            return  this.dataInteraction
        },        
    },

    methods: {        
        
        get(attr) {
            if (!this.item.estilo ||
                !this.item.estilo[attr] ||
                !this.item.estilo[attr].color)
                return false

            return this.item.estilo[attr].color
        },

        set({color, attr}) {            
            const style = _.cloneDeep(this.style)
            
            style[attr].color = color

            style["backgroundType"] = "COLOR"
           
            if(attr === "backgroundColorInteraction") {
                typeof color === "string" ? style[attr].isGradient = true : style[attr].isGradient = false
            }
            const data = {
                estilo: style
            }
            
            this.$store.commit('SET_INTERACTION_DATA', {
                interactionId: this.dataInteraction.id,
                data
            })
            this.setTimeout({
                interaction: this.dataInteraction,
                data
            })
        },

        isValidColorSelection(val) {
            if(val.color.a > 0.5) {
                return true;
            }

            const textAlpha = this.color.a;
            const backgroundAlpha = this.backgroundColor.a;
            const borderAlpha = this.borderColor.a;

            const isValid = {
                'backgroundColor': textAlpha >= 0.5 || borderAlpha >= 0.5,
                'borderColor': textAlpha >= 0.5 || backgroundAlpha >= 0.5,
                'color': backgroundAlpha >= 0.5 || borderAlpha >= 0.5
            }[val.attr]


            if(!isValid) {
                EventBus.$emit('show-message', {
                    type: 'ERROR',
                    message: this.$t('message.errorMessages.message.attributesOpacity')
                })
            }

            return isValid;
        },
        
        
        setTimeout({interaction, data}) {
            if (this.timeout)
                clearTimeout(this.timeout)

            this.timeout = setTimeout(() => this.commit({interaction, data}), 600)
        },

        commit({interaction, data}) {
            const payload = {
                advertisingId: interaction.campanhaId,
                interactionId: interaction.id,                      
                data,
            } 
            
            this.$api.interactions.update(payload)
        },
        
        emitSelectedFalse() {
            this.$emit('selectedFalse')
        }
        
    },
   
}
</script>
  
<style lang="scss" scoped>
  .color-picker-wrapper {
    width: 100%;
  }
</style>
  